import type { RunStatus } from "../../api/types"
import { cn } from "../../lib/cn"

const STATE_STYLE: Record<RunStatus, { dot: string; text: string; label: string }> = {
  queued: { dot: "bg-text-muted", text: "text-text-muted", label: "queued" },
  running: { dot: "bg-info", text: "text-info", label: "running" },
  success: { dot: "bg-success", text: "text-success", label: "success" },
  partial: { dot: "bg-warning", text: "text-warning", label: "partial" },
  failed: { dot: "bg-danger", text: "text-danger", label: "failed" },
  cancelled: { dot: "bg-text-muted", text: "text-text-muted", label: "cancelled" },
  cost_exceeded: { dot: "bg-danger", text: "text-danger", label: "cost exceeded" },
  unknown: { dot: "bg-text-muted", text: "text-text-muted", label: "unknown" },
}

export function StatusPill({ state }: { state: RunStatus | string | undefined | null }) {
  const key = (state ?? "unknown") as RunStatus
  const style = STATE_STYLE[key] ?? STATE_STYLE.unknown
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-surface-2 px-2 py-0.5">
      <span className={cn("size-1.5 rounded-full", style.dot)} />
      <span className={cn("text-[11px] font-medium", style.text)}>{style.label}</span>
    </span>
  )
}
